// data-test attributes for components
export var DataTestAttributes = /*#__PURE__*/function (DataTestAttributes) {
  DataTestAttributes["ADD_CARD_CANCEL_BUTTON"] = "ADD-CARD-CANCEL-BUTTON";
  DataTestAttributes["ADD_CARD_FORM_HEADER_FOOTER"] = "ADD-CARD-FORM-HEADER-FOOTER";
  DataTestAttributes["ADD_PAYMENT_METHOD_LINK"] = "ADD_PAYMENT_METHOD_LINK";
  DataTestAttributes["ADD_VENMO_BUTTON"] = "ADD_VENMO_BUTTON";
  DataTestAttributes["ADD_VENMO_CANCEL_BUTTON"] = "ADD-VENMO-CANCEL-BUTTON";
  DataTestAttributes["AMERICAN_EXPRESS_CARD"] = "AMERICAN-EXPRESS-CARD-LOGO";
  DataTestAttributes["CANCEL_BUTTON"] = "CANCEL-BUTTON";
  DataTestAttributes["CARD_NUMBER"] = "CARD_NUMBER";
  DataTestAttributes["CARD_VIEW_CONTAINER"] = "CARD-VIEW-CONTAINER";
  DataTestAttributes["CARDHOLDER_NAME"] = "CARDHOLDER-NAME";
  DataTestAttributes["CARDHOLDER_NAME_INPUT"] = "CARDHOLDER-NAME-INPUT";
  DataTestAttributes["CC_FORM_SUBMIT_BUTTON"] = "CC-FORM-SUBMIT-BUTTON";
  DataTestAttributes["CHECKBOX_CONTAINER"] = "CHECKBOX-CONTAINER";
  DataTestAttributes["CREDIT_CARD_FORM"] = "CREDIT-CARD-FORM";
  DataTestAttributes["CREDIT_CARD_FORM_CONTAINER"] = "CREDIT-CARD-FORM-CONTAINER";
  DataTestAttributes["CREDIT_CARD_FORM_HEADER"] = "CREDIT-CARD-FORM-HEADER";
  DataTestAttributes["CVV"] = "CVV";
  DataTestAttributes["DEFAULT_MOP_VIEW"] = "DEFAULT_MOP_VIEW";
  DataTestAttributes["DINERSCLUB_CARD"] = "DINERSCLUB-CARD-LOGO";
  DataTestAttributes["DISCOVER_CARD"] = "DISCOVER-CARD-LOGO";
  DataTestAttributes["DIVIDER"] = "DIVIDER";
  DataTestAttributes["DROPDOWN_DETAIL_BOX"] = "DROPDOWN-DETAIL-BOX";
  DataTestAttributes["DROPDOWN_OPTIONS_LIST"] = "DROPDOWN-OPTIONS-LIST";
  DataTestAttributes["EDIT_CARD_SELECTION"] = "EDIT-CARD-SELECTION";
  DataTestAttributes["EDIT_MOP_LINK"] = "EDIT-MOP-LINK";
  DataTestAttributes["EXISTING_CARD_CONTAINER"] = "EXISTING-CARD-CONTAINER";
  DataTestAttributes["EXISTING_CARD_DESCRIPTION"] = "EXISTING-CARD-DESCRIPTION";
  DataTestAttributes["EXISTING_CARD_TEXT"] = "EXISTING-CARD-TEXT";
  DataTestAttributes["EXISTING_MOP_TEXT"] = "EXISTING-MOP-TEXT";
  DataTestAttributes["EXISTING_PAYPAL_DESCRIPTION"] = "EXISTING-PAYPAL-DESCRIPTION";
  DataTestAttributes["EXPIRATION_DATE"] = "EXPIRATION-DATE";
  DataTestAttributes["GIFT_CODE"] = "GIFT-CODE";
  DataTestAttributes["MASTER_CARD"] = "MASTER-CARD-LOGO";
  DataTestAttributes["MESSAGE_BOX"] = "MESSAGE-BOX";
  DataTestAttributes["MOP_CANCEL_BUTTON"] = "MOP-CANCEL-BUTTON";
  DataTestAttributes["MOP_CTA_CONTAINER"] = "MOP-CTA-CONTAINER";
  DataTestAttributes["MOP_DISPLAY_CONTAINER"] = "MOP-DISPLAY-CONTAINER";
  DataTestAttributes["MOP_EDIT_BUTTON"] = "MOP-EDIT-BUTTON";
  DataTestAttributes["MOP_HEADLINE"] = "MOP_HEADLINE";
  DataTestAttributes["MOP_LIST"] = "MOP_LIST";
  DataTestAttributes["MOP_USER_ADDRESS"] = "MOP-USER-ADDRESS";
  DataTestAttributes["MOP_USER_COUNTRY"] = "MOP-USER-COUNTRY";
  DataTestAttributes["MOP_USER_NAME"] = "MOP-USER-NAME";
  DataTestAttributes["NOTIFICATION_BANNER"] = "NOTIFICATION-BANNER";
  DataTestAttributes["NOTIFICATION_BANNER_WRAPPER"] = "NOTIFICATION-BANNER-WRAPPER";
  DataTestAttributes["PAYMENT_BUTTONS"] = "PAYMENT-BUTTONS";
  DataTestAttributes["PAYMENT_FORM_HEADER"] = "PAYMENT_HEADER";
  DataTestAttributes["PAYMENT_OPTIONS"] = "PAYMENT_OPTIONS";
  DataTestAttributes["RUPAY_CARD"] = "RUPAY-CARD-LOGO";
  DataTestAttributes["SELECTED_MOP_VIEW"] = "SELECTED-MOP-VIEW";
  DataTestAttributes["VENMO_CARD"] = "VENMO_CARD_LOGO";
  DataTestAttributes["VERIFY_ADDRESS_FORM"] = "VERIFY-ADDRESS-FORM";
  DataTestAttributes["VERIFY_ADDRESS_FORM_CONTAINER"] = "VERIFY-ADDRESS-FORM-CONTAINER";
  DataTestAttributes["VISA_CARD"] = "VISA-CARD-LOGO";
  DataTestAttributes["VISUALLY_HIDDEN_HEADER"] = "VISUALLY_HIDDEN_HEADER";
  DataTestAttributes["UPDATE_BUTTON"] = "UPDATE_BUTTON";
  DataTestAttributes["UPI_OPTIONS"] = "UPI-OPTIONS";
  DataTestAttributes["UPI_OPTIONS_HEADER"] = "UPI-OPTIONS-HEADER";
  DataTestAttributes["UPI_FORM_HEADER"] = "UPI-FORM-HEADER";
  DataTestAttributes["UPI_FORM"] = "UPI-FORM";
  DataTestAttributes["UPI_FORM_NAME"] = "UPI-FORM-NAME";
  DataTestAttributes["UPI_FORM_PHONE"] = "UPI-FORM-PHONE";
  DataTestAttributes["UPI_PROCESSING"] = "UPI-PROCESSING-MODAL";
  DataTestAttributes["UPI_PROCESSING_ICON"] = "UPI-PROCESSING-ICON";
  DataTestAttributes["RECURLY_APPLEPAY_BUTTON"] = "RECURLY-APPLEPAY-BUTTON";
  DataTestAttributes["RECURLY_PAYPAL_BUTTON"] = "RECURLY-PAYPAL-BUTTON";
  DataTestAttributes["RECURLY_GOOGLEPAY_BUTTON"] = "RECURLY-GOOGLEPAY-BUTTON";
  DataTestAttributes["RECURLY_VENMO_BUTTON"] = "RECURLY-VENMO-BUTTON";
  DataTestAttributes["ADD_MOP_MAKE_DEFAULT_CHECKBOX"] = "ADD_MOP_MAKE_DEFAULT_CHECKBOX";
  DataTestAttributes["UPDATE_MOP_MAKE_DEFAULT_CHECKBOX"] = "UPDATE_MOP_MAKE-DEFAULT-CHECKBOX";
  DataTestAttributes["MAKE_BACKUP_CHECKBOX"] = "MAKE-BACKUP-CHECKBOX";
  return DataTestAttributes;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/constants/DataTestAttributes.js
// module id = 55
// module chunks = 11